module.exports = __webpack_public_path__ + "media/images/home_venue-54b7e77d9f9043cec580de80bc997d3b.png";